import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import jwtDecode from 'jwt-decode'

import { AccessToken } from 'types'
import App from '@/components/App'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://3ba9c011295544819e629dbe3260eae3@o1239792.ingest.sentry.io/6391560',
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0,
  })

  if (sessionStorage.getItem('accessToken')) {
    try {
      Sentry.setContext(
        'user_token',
        jwtDecode<AccessToken>(sessionStorage.getItem('accessToken') ?? ''),
      )
    } catch (e) {}
  }
}

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)
  root.render(<App key={Math.random()} />)
}
